import { useEffect, useState } from '@wordpress/element';
import { CampoInput } from '@componentsNew/Input/CampoInput';

function Breadcrumbs({ nota, carregando }) {

  return (
    <CampoInput
      label={'Título do caminho de navegação'}
      carregando={carregando}
      campoEstrutura={'breadcrumbs'}
      desabilidato={true}
      nota={nota}
    />
  );
}

export default Breadcrumbs;
